import styled from 'styled-components';

import { defaultFontSizeCSS } from '@styles/generalStyles';

export const StyledLoyaltyWrapper = styled.div`
  ${defaultFontSizeCSS};
`;
